<!--
 This is the main component for rendering a blank content asset
for the purposes of urlbox.
-->
<template>
  <div class="content_asset_raw" v-if="contentAsset && loaded">
    <AssetPresenter
      :content_asset="contentAsset"
      :stat_color_option="statColorOption"
      :background_color_option="backgroundColorOptionComputed"
      :design="theDesign"
      :shape="shape"
      :show_all_pages="!page"
      :page="page"
      :account="account"
      :theme="theme"
    />
  </div>
</template>

<script lang="ts">
import AssetPresenter from '@survey/components/AssetPresenter.vue'
import { fetchPublicContentAsset, getTestimonialTheme } from '@app/api.js'
import appsignal from '@lib/appsignal'

export default {
  components: { AssetPresenter },
  // TODO:
  // These props are a mess.  different assets use different
  // combinations of them.  they get mutated back and forth between
  // snake case from the URL, into camel case then back to sanke as they flow
  // from here, to AssetPresenter, then into their respective asset components.
  // we should first document their permutations are then we should refactor
  // all of this to be more clear.
  props: {
    content_asset_id: { type: String, required: true },
    statColorOption: { type: String, default: 'primary' },
    backgroundColorOption: { type: String, default: 'primary' },
    shape: { type: String, default: 'flex' },
    page: { type: String, default: null },
    theme_id: { type: String, default: null },
    theme_type: { type: String, default: null },
    design: { type: String, default: null },
  },
  data() {
    return {
      contentAsset: null,
      theme: null,
      loaded: false,
    }
  },
  computed: {
    account() {
      return this.contentAsset.account
    },
    // testmonials have theme_type, so we coerce it into
    // the design prop for the AssetPresenter
    theDesign() {
      return this.design || this.theme_type
    },
    backgroundColorOptionComputed() {
      switch (this.theme_type) {
        case 'branded_primary':
          return 'primary'
        case 'branded_secondary':
          return 'secondary'
        case 'branded_primary_and_secondary':
          return 'both'
        default:
          return this.backgroundColorOption
      }
    },
  },
  beforeMount() {
    const theParams = Object.assign({}, this.$route.query, { is_screenshot: true })
    // this uses the non app version of the content asset api
    // (aka the one that the research libary uses)
    // which only shows 'public' assets.
    // since we arrive at this vue component from a urlbox
    // request, we'll have the 'urlbox token' in the query params
    // which we pass through.  this allows this request to show
    // non public assets so that urlbox can 'see'
    // the asset do its thing.
    fetchPublicContentAsset(this.content_asset_id, theParams)
      .then((r) => {
        this.contentAsset = r.data.content_asset

        if (this.contentAsset.type == 'RenderableTestimonial' && this.theme_id) {
          getTestimonialTheme(this.theme_id).then((resp) => {
            this.theme = resp.data
            this.loaded = true
          })
        } else {
          this.loaded = true
        }
      })
      .catch((e) => {
        appsignal.sendError(e, (span) => {
          span.setAction('fetchPublicContentAsset')
          span.setNamespace('Raw')
          span.setParams({ content_asset_id: this.content_asset_id })
        })
      })
  },
}
</script>
<style lang="sass"></style>
